import React from "react";

export const AppearanceLabel = ({ children = [] }: any) => {
    return <strong>{children}</strong>;
};
